module.exports = __webpack_public_path__ + "static/media/Custom_temp_4.9d698276.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/superdry/Custom_temp_4.jpg
// module id = 2093
// module chunks = 0